(() => {
  if (window.iStoreCardRailLoaded) return;
  window.iStoreCardRailLoaded = true;

  const setupRail = (rail) => {
    if (rail.dataset.iStoreCardRailReady === "true") return;

    const viewport = rail.querySelector(".istore-card-rail__viewport");
    const track = rail.querySelector(".istore-card-rail__track");
    const previousButton = rail.querySelector("[data-istore-rail-previous]");
    const nextButton = rail.querySelector("[data-istore-rail-next]");

    if (!viewport || !track || !previousButton || !nextButton) return;

    rail.dataset.iStoreCardRailReady = "true";

    const getStep = () => {
      const firstCard = track.querySelector(".istore-card-rail__item");
      const gap =
        Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;

      return firstCard
        ? firstCard.getBoundingClientRect().width + gap
        : viewport.clientWidth * 0.8;
    };

    const getScrollBehavior = () =>
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth";

    const updateControls = () => {
      const maximumScroll = Math.max(
        0,
        viewport.scrollWidth - viewport.clientWidth,
      );
      const hasOverflow = maximumScroll > 1;

      previousButton.parentElement.hidden = !hasOverflow;
      previousButton.disabled = !hasOverflow || viewport.scrollLeft <= 1;
      nextButton.disabled =
        !hasOverflow || viewport.scrollLeft >= maximumScroll - 1;
    };

    previousButton.addEventListener("click", () => {
      viewport.scrollBy({ left: -getStep(), behavior: getScrollBehavior() });
    });

    nextButton.addEventListener("click", () => {
      viewport.scrollBy({ left: getStep(), behavior: getScrollBehavior() });
    });

    viewport.addEventListener("scroll", updateControls, { passive: true });

    if ("ResizeObserver" in window) {
      new ResizeObserver(updateControls).observe(viewport);
    } else {
      window.addEventListener("resize", updateControls, { passive: true });
    }

    updateControls();
  };

  const setupRails = (scope = document) => {
    scope.querySelectorAll("[data-istore-card-rail]").forEach(setupRail);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setupRails(), {
      once: true,
    });
  } else {
    setupRails();
  }

  document.addEventListener("shopify:section:load", (event) =>
    setupRails(event.target),
  );
})();
